
function selectcardController($scope, $routeParams, $location, ctapickacardSvc) {
  'ngInject';


    $scope.PlanId = $routeParams.PlanId;
    $scope.Quantity = $routeParams.Quantity;
    $scope.NumberOfTickets = $routeParams.NumberOfTickets;
    $scope.Total = $routeParams.Total;

    if ($scope.Quantity > 1) {
      $scope.TicketsVerb = 'PurchaseTicketPlural'
    } else {
      $scope.TicketsVerb = 'PurchaseTicketSingular'
    }

    ctapickacardSvc.get({OrganizationId: TFL_ID }, function (data) {
      $scope.Deck = data;
    });


    // used in select-card.html
    $scope.Deck_old = [
      {num: 1, drawn: true, suit: 'spades', number: 'K' }, 
      {num: 2, drawn: true, suit: 'hearts', number: 'K'}, 
      {num: 3}, 
      {num: 4}, 
      {num: 5, drawn: true, suit: 'clubs', number: 'K'}, 
      {num: 6, drawn: true, suit: 'diamonds', number: 'K'}, {num: 7}, {num: 8}, {num: 9}, {num: 10}, {num: 11}, {num: 12}, {num: 13}, {num: 14}, {num: 15}, {num: 16}, {num: 17}, {num: 18}, {num: 19}, {num: 20}, {num: 21}, {num: 22}, {num: 23}, {num: 24}, {num: 25}, {num: 26}, {num: 27}, {num: 28}, {num: 29}, {num: 30}, {num: 31}, {num: 32}, {num: 33}, {num: 34}, {num: 35}, {num: 36}, {num: 37}, {num: 38}, {num: 39}, {num: 40}, {num: 41}, {num: 42}, {num: 43}, {num: 44}, {num: 45}, {num: 46}, {num: 47}, {num: 48}, {num: 49}, {num: 50}, {num: 51}
    ];

    // click to choose card (boolean to allow only one choice)
    jQuery(document).ready(function ($) {
      $scope.ChooseCard = function () {
        if (this.card.drawn != true) {
          angular.forEach($scope.Deck, function (c, i) {
            c.chosen = false;
          });
          this.card.chosen = true;
          $scope.SelectedNumber = this.card.num;
          $scope.SelectedId = this.card.id;

          $('.sticky-nav').removeClass('disabled');
        }
      }
    });

    $scope.CheckOut = function() {
      $location.url($location.path('/adding-cta-cart/' + $scope.PlanId + '/' + $scope.Quantity + '/' + $scope.SelectedId).replace());
      $location.path('/adding-cta-cart/' + $scope.PlanId + '/' + $scope.Quantity + '/' + $scope.SelectedId).replace();
    }

};

export default {
  name: 'selectcardController',
  fn: selectcardController
}